<ng-container *ngFor="let flag of visibleFlags">
    <icc-checkbox
        [iccFlagElement]="flag"
        *ngIf="showFlag(flag.code) && canFlagBeChanged(flag.code, flag.kind === 'builtin')"
        [ngModel]="flag.kind === 'builtin' ? document[flag.code] : document.flags[flag.code]"
        (ngModelChange)="changeFlag($event, flag.code, flag.kind === 'builtin')"
        [name]="flag.code"
        [class.icc-checkbox-vertical]="vertical"
    >
        {{ flag.name || ('INTERFACE|Niezdefiniowany' | translate) }}
    </icc-checkbox>
    <icc-static-flag
        [iccFlagElement]="flag"
        *ngIf="showFlag(flag.code) && !canFlagBeChanged(flag.code, flag.kind === 'builtin')"
        [checked]="flag.kind === 'builtin' ? document[flag.code] : document.flags[flag.code]"
        [class.icc-checkbox-vertical]="vertical"
    >
        {{ flag.name || ('INTERFACE|Niezdefiniowany' | translate) }}
    </icc-static-flag>
</ng-container>

<span class="spacer"></span>
<button [iccMenuTriggerFor]="documentFlagsMenu" iccIconButton appearance="flat-base" class="document-flags-more" #origin><icc-icon name="more_horizontal"></icc-icon></button>

<icc-menu #documentFlagsMenu="iccMenu" xPosition="before" yPosition="below">
    <div class="documents-options-menu">
        <ng-container *ngFor="let flag of overflowFlags">
            <icc-checkbox
                *ngIf="showFlag(flag.code) && canFlagBeChanged(flag.code, flag.kind === 'builtin')"
                [ngModel]="flag.kind === 'builtin' ? document[flag.code] : document.flags[flag.code]"
                (ngModelChange)="changeFlag($event, flag.code, flag.kind === 'builtin')"
                [name]="flag.code"
                [class.icc-checkbox-vertical]="vertical"
            >
                {{ flag.name }}
            </icc-checkbox>
            <icc-static-flag
                *ngIf="showFlag(flag.code) && !canFlagBeChanged(flag.code, flag.kind === 'builtin')"
                [checked]="flag.kind === 'builtin' ? document[flag.code] : document.flags[flag.code]"
                [class.icc-checkbox-vertical]="vertical"
            >
                {{ flag.name }}
            </icc-static-flag>
        </ng-container>
    </div>
</icc-menu>